import { render, staticRenderFns } from "./ChatType.vue?vue&type=template&id=236bf4fa&scoped=true&"
import script from "./ChatType.vue?vue&type=script&lang=js&"
export * from "./ChatType.vue?vue&type=script&lang=js&"
import style0 from "./ChatType.vue?vue&type=style&index=0&id=236bf4fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236bf4fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('236bf4fa')) {
      api.createRecord('236bf4fa', component.options)
    } else {
      api.reload('236bf4fa', component.options)
    }
    module.hot.accept("./ChatType.vue?vue&type=template&id=236bf4fa&scoped=true&", function () {
      api.rerender('236bf4fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chat/chatChartSupervise/components/ChatType.vue"
export default component.exports